// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarCentroEstudios_main__-9VeW","intro":"ModalEditarCentroEstudios_intro__ZIj11","input":"ModalEditarCentroEstudios_input__5lG+d"};